import {
    getMsalInstance,
    isAzureSsoConfigured,
    parseAzureAdScopes,
} from 'store/auth/msalConfig';
import createAction from 'store/utils/createAction';
import { resetAuthTokens } from 'utilities/authTokens';

const serviceName = 'auth';

export const setTokensFromStorage = createAction(
  `${serviceName}/SET_TOKENS_FROM_COOKIE`
);

export const signOut = createAction(`${serviceName}/LOGOUT_USER`);

/**
 * Initiates the Azure AD login redirect flow.
 */
export const startAzureLoginRedirect = async () => {
  if (!isAzureSsoConfigured()) {
    return;
  }
  const instance = getMsalInstance();
  if (!instance) {
    return;
  }
  await instance.loginRedirect({
    scopes: parseAzureAdScopes(),
  });
};

/**
 * Logs out the user: clears app tokens and triggers MSAL logout redirect.
 */
export const performLogout = async () => {
  resetAuthTokens();

  const instance = getMsalInstance();
  if (instance?.getAllAccounts()?.length) {
    const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0];
    await instance.logoutRedirect({
      account,
      postLogoutRedirectUri: `${window.location.origin}/auth`,
    });
  } else {
    window.location.href = '/auth';
  }
};
